import { styled } from 'styled-components';

export const Row = styled.div`
    display: grid;
    grid-template-columns: 2.7fr 1fr 1fr 1fr minmax(130px, 1fr) 110px;
    gap: 20px;

    padding: 0 0 15px 0;
    width: fit-content;
    min-width: 100%;
`;

export const InfoCell = styled.div`
    display: flex;
    align-items: center;
    min-width: 220px;

    background-color: #090719;
    position: sticky;
    left: 0;

    padding-left: 12px;
`;
